import {
    LOGOUT_START,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,


} from '../../constants';

import { ApiBase } from '../../../utils/apiBase';
import { withType } from '../../../utils/actionOperations';
import { LOGOUT_URL } from '../../../../config/constants';


export const logoutAction = (cb) => {
    const apiBaseInstance = new ApiBase();

    return dispatch => {
        dispatch(withType(LOGOUT_START, {

        }));
        apiBaseInstance.instance
            .post(LOGOUT_URL,
                { })
            .then(response => {
                dispatch(withType(LOGOUT_SUCCESS, { }));
                cb && cb(true)
            })
            .catch(err => {
                dispatch(withType(LOGOUT_FAIL, {
                    error: err
                }));
                cb && cb(false)
            });
    };
};

